import React from 'react';

export default function HeroScrollCue({ href }) {
  return (
    <a className="church-scroll-cue" href={href}>
      <span>Scroll to explore</span>
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="m4 6 4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </a>
  );
}
